module.exports = __webpack_public_path__ + "assets/img/modal-bg.83b02fdc.jpg";